import AllTheCircleButtons from './components/AllTheCircleButtons.react.js';
import Nav from "./components/Nav.react";
import Masthead from "./components/Masthead.react";
import Contact from "./components/Contact.react.js";
import Bio from "./components/Bio.react.js";
import Signup from "./components/Signup.react";
import Upsell from "./components/Upsell.react";

const bios = require("./data/bios.json");
const IMDB_URL = 'https://www.imdb.com/title/tt37996049/fullcredits/';

function Cast() {
  return (
    <>
      <Nav />
      <Masthead tab="cast" buttonLabel="Meet the cast & crew" />
      <section className="projects-section bg-light">
        <div className="container px-4 px-lg-5">
          <div className="row gx-0 mb-4 mb-lg-5 align-items-center">
            <div className="col-md-6">
              <img
                className="img-fluid mb-3 mb-lg-0"
                src="./favicon.svg"
                alt="Dark Northwest logo"
                width="80%"
              />
            </div>
            <div className="col-md-6">
              <div className="featured-text text-center text-lg-left">
                <h3 id="about">Meet the Main Cast and Crew</h3>
                <p className="text-black-50 mb-0" >
                  See full credits on {' '}
                  <a href={IMDB_URL} target="_blank" rel="noreferrer">
                    IMDb{' '}
                    <i className="fa-solid fa-arrow-up-right-from-square"></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
          {bios.map((member, idx) => {
            return (
              <Bio
                key={member.name}
                bio={member}
                flavor={idx % 2 === 0 ? "A" : "B"}
              />
            );
          })}
        </div>
      </section>
      {/* <section className="projects-section bg-light" id="full-cast">
         <div className="container px-4 px-lg-5">
        </div>
      </section> */}
      <Upsell />
      <Signup />
      <AllTheCircleButtons />
      <Contact />
    </>
  );
}

export default Cast;
